<template>
  <div>{{ empty_space }}</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    watch: {
      time_remaining( newValue, oldValue ) {
        document.title = this.timer_status === 'running' ? this.$filters.hoursMinutesSeconds(this.time_remaining) + ' Goalpilot - Goalpilot.com' : 'Goalpilot - Goalpilot.com'
      },
      timer_status( newValue, oldValue) {
        if (newValue !== 'running' && newValue !== 'paused') {
          document.title = 'Goalpilot - Goalpilot.com'
        }
      }
    },
    computed: {
      ...mapGetters('session', [
        'session_timer_status',
        'session_time_remaining',
        'session_user_timer'
      ]),
      time_remaining() {
        if (this.$models.user.defaultUserId && this.session_user_timer && this.session_user_timer.$ready && this.session_user_timer.taskId) {
          return this.session_time_remaining(this.session_user_timer.taskId)
        } else {
          return 0
        }
      },
      timer_status() {
        if (this.$models.user.defaultUserId && this.session_user_timer && this.session_user_timer.$ready && this.session_user_timer.taskId) {
          return this.session_timer_status(this.session_user_timer.taskId)
        } else {
          return 'stopped'
        }
      },
      empty_space() {
        return ''
      }
    }
}
</script>
